import { render, staticRenderFns } from "./copy-section.vue?vue&type=template&id=290180b5&"
import script from "./copy-section.vue?vue&type=script&lang=js&"
export * from "./copy-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports